import {ConditionsProps} from "../../utils/segmentBuilder";
import {CheckCircleFilled, CheckCircleOutlined, CheckOutlined, WarningOutlined} from "@ant-design/icons";
import {ThumbsUp} from "../../assets/icons/ThumbsUp";
import {WarningIcon} from "../../assets/icons/WarningIcon";

const SegmentBuilderHint = ({ conditions, error, isEditMode }: { conditions: ConditionsProps; error: string; isEditMode: boolean }) => {
    return (
        <div className="segment-hint">
            <div className="segment-hint-icon">
                <div className="warning-icon"><WarningIcon width={36} color='#ffd23f' /></div>
                <div className="approval-icon"><ThumbsUp width={36} color='#8a5de7' /></div>
            </div>
            {error ? <div>{error}</div> : <div>Nice work!<br /> Your condition is valid. Continue building your segment.</div>}
        </div>
    );

    // if(error) {
    //     return <div className="segment-hint warning">
    //         <WarningIcon width={36} color='#ffd23f' />
    //         <div>{error}</div>
    //     </div>;
    // }
    // return <div className="segment-hint approved">
    //     <ThumbsUp width={36} color='#8a5de7' />
    //     <div>Nice work!<br /> Your condition is valid. Continue building your segment.</div>
    // </div>
};

export default SegmentBuilderHint;